import metrics from "@common/metrics.css";
import { throws } from "@util/validation";

export const VIEW_RATES_HOTEL_CARD_POSITIONING_DELAY = metrics.transitionSpeed.endsWith(
  "ms"
)
  ? parseInt(metrics.transitionSpeed, 10) + 50
  : throws(new Error("transitionSpeed needs to be defined in ms"));
